import { connect } from 'react-redux';

import { getFormByCode } from 'redux/forms/reducers';

import Form from './Form';

const FormWrapper = (props) => {
  const { settings, c7Form, node, code } = props;
  const { customerMetaData } = props;
  if (!settings.data || !c7Form || !customerMetaData.data) {
    return null;
  }
  return <Form code={code} node={node} form={c7Form.code} />;
};

const mapStateToProps = (state, ownProps) => ({
  c7Form: getFormByCode(state.forms, ownProps.code),
  customerMetaData: state.customerMetaData,
  settings: state.setting
});

export default connect(mapStateToProps)(FormWrapper);
